import { Component, Input, OnInit } from "@angular/core";
import { OrderService } from "src/app/services/order/order.service";
import { PaymentService } from "src/app/services/payment/payment.service";
import { SaleService } from "src/app/services/sale/sale.service";

@Component({
  selector: "status-history",
  templateUrl: "./status-history.component.html",
  styleUrls: ["./status-history.component.scss"]
})
export class StatusHistoryComponent implements OnInit {
  @Input()
  mode: string; // edit, view, order, catalog, sale

  @Input()
  statuses: [];

  @Input()
  role: string;

  @Input()
  type:string;

  constructor(
    public paymentService:PaymentService,
    public orderService:OrderService,
    public saleService:SaleService
  ) {}

  ngOnInit() {}
}
